import { combineReducers } from '@reduxjs/toolkit';
import { reducer as routes } from '../comp/flightRoutesTable';
import { filtersOptions, filtersValues } from '../comp/flightRoutesFilters';

export default combineReducers({
  routes,
  filtersOptions,
  filtersValues,
});
